import { Modal, Radio, type RadioChangeEvent } from 'antd';
import React, { useEffect, useState } from 'react';

export interface ConfirmModalProps {
  open: boolean;
  confirmLoading?: boolean;
  onConfirm: (saveToNextIterations: boolean) => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  confirmLoading = false,
  onConfirm,
  onCancel,
}) => {
  const [value, setValue] = useState(1);

  useEffect(() => {
    if (open) {
      setValue(1);
    }
  }, [open]);

  const onChange = (e: RadioChangeEvent): void => {
    setValue(e.target.value);
  };

  return (
    <Modal
      open={open}
      title="Confirm saving cycle menu"
      confirmLoading={confirmLoading}
      width={600}
      onOk={() => {
        onConfirm(value === 1);
      }}
      onCancel={onCancel}
    >
      <Radio.Group
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        onChange={onChange}
        value={value}
        options={[
          {
            value: 1,
            label: 'Apply to the current iteration and the following ones',
          },
          { value: 2, label: 'Apply to the current iteration only' },
        ]}
      />
    </Modal>
  );
};

ConfirmModal.displayName = 'ConfirmModal';
export default ConfirmModal;
